import type { CitiesTranslation } from './types'

/**
 * English translations for Cities domain
 */
export const citiesTranslationEn: CitiesTranslation = {
  // Page/Section level
  title: 'Cities',
  subtitle: 'Manage cities within geographic regions',

  // Actions
  addCity: 'Add City',
  editCity: 'Edit City',
  deleteCity: 'Delete City',

  // Drawer Headers
  addCityDescription: 'Fill in the details to create a new city',
  editCityDescription: 'Update the city details below',
  viewCityDescription: 'View city information',

  // Search and states
  searchPlaceholder: 'Search cities...',
  noCities: 'No Cities Found',
  noCitiesDescription:
    'No cities have been configured yet. Add your first city to start managing locations.',
  addFirst: 'Add Your First City',

  // Form fields
  code: 'City Code',
  codePlaceholder: 'e.g., RYD, JED',
  name: 'City Name (English)',
  namePlaceholder: 'e.g., Riyadh',
  nameArabic: 'City Name (Arabic)',
  nameArabicPlaceholder: 'e.g., الرياض',
  stateProvince: 'State/Province (English)',
  stateProvincePlaceholder: 'e.g., Riyadh Province',
  stateProvinceArabic: 'State/Province (Arabic)',
  stateProvinceArabicPlaceholder: 'e.g., منطقة الرياض',
  salesDistrict: 'SAP Sales District',
  salesDistrictPlaceholder: 'e.g., 0001',
  basicInformation: 'Basic information',
  arabicOptional: 'Arabic (optional)',
  region: 'Region',
  selectRegion: 'Select region',
  country: 'Country',
  selectCountry: 'Select country',
  status: 'Status',

  // Status values
  active: 'Active',
  inactive: 'Inactive',
  all: 'All',

  // Stats
  totalCities: 'Total Cities',
  activeCities: 'Active',
  inactiveCities: 'Inactive',

  // Table headers
  table: {
    code: 'Code',
    name: 'Name',
    region: 'Region',
    country: 'Country',
    stateProvince: 'State/Province',
    salesDistrict: 'Sales District',
    status: 'Status',
    actions: 'Actions',
  },

  // Card content
  card: {
    region: 'Region',
    country: 'Country',
    noRegion: 'No region assigned',
    noCountry: 'No country assigned',
  },

  // Messages
  messages: {
    createSuccess: 'City Created',
    createSuccessDescription: 'The new city has been created successfully.',
    updateSuccess: 'City Updated',
    updateSuccessDescription: 'The city has been updated successfully.',
    deleteSuccess: 'City Deleted',
    deleteSuccessDescription: 'The city has been removed.',
    deleteConfirm: 'Delete City',
    deleteConfirmDescription:
      'Are you sure you want to delete this city? This may affect addresses and locations.',
    loadError: 'Failed to load cities. Please try again.',
  },

  // Validation
  validation: {
    codeRequired: 'City code is required',
    codeInvalid: 'City code must be alphanumeric and uppercase',
    nameRequired: 'City name is required',
    regionRequired: 'Region is required',
  },

  // Filter
  filter: {
    all: 'All Status',
    active: 'Active Only',
    inactive: 'Inactive Only',
    byRegion: 'Filter by Region',
    allRegions: 'All Regions',
  },
}
